export const validateCheckbox = (checked, item) => {
    if (item.Checkbox.IsCheckboxMandatory) { //If checkbox is mandatory
        if (checked) { //If checkbox is checked
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
}